import { render, staticRenderFns } from "./DesktopGame.vue?vue&type=template&id=306b6efd"
import script from "./DesktopGame.vue?vue&type=script&lang=js"
export * from "./DesktopGame.vue?vue&type=script&lang=js"
import style0 from "./DesktopGame.vue?vue&type=style&index=0&id=306b6efd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports